import { PopoverController } from '@ionic/angular';
import { InscricaoDTO } from '../../../../models/agendamento/inscricaoDTO';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-popover-listar-inscricoes',
  templateUrl: './popover-listar-inscricoes.component.html',
  styleUrls: ['./popover-listar-inscricoes.component.scss'],
})
export class PopoverListarInscricoesComponent implements OnInit {

  constructor( private popoverController: PopoverController ) { }

  inscricoes: InscricaoDTO[];

  ngOnInit() {}


  find(idInscricao: number){

    //fecha o popover e indica o id da inscrição para disparar o método find do componente header-gc
    this.popoverController.dismiss(idInscricao);
  }
}
